import mixpanel from "mixpanel-browser";

export const trackShare = () => {
  mixpanel.track("Share clicked");
};

export const testTrack = () => {
  console.log("testTrack");
};
